module.exports = __webpack_public_path__ + "img/banner10.43f5feb2.jpeg";